export const SET_DATA = 'profileProcesses/SET_DATA'
export const SET_DOCUMENTS = 'profileProcesses/SET_DOCUMENTS'
export const SET_IS_FETCHING = 'profileProcesses/SET_IS_FETCHING'
export const SET_COMMENTS = 'profileProcesses/SET_COMMENTS'
export const SET_USER = 'profileProcesses/SET_USER'
export const RESET_DATA = 'profileProcesses/RESET_DATA'
